import * as React from 'react';
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css"
import {AttributeTypeEnum} from "../../enums/AttributeTypeEnum";
import Axios from "../../../../config/Axios";
import Utils from "../../../../Utils";
import toastr from "toastr";
import AgSelectAllHeader from "../../common/AgSelectAllHeader";
import {helpHeaderTemplate} from "../../common/AgHeaderHelpToolTip";
import AgGridFooter from "../../common/AgGridFooter";
import history from '../../../../config/history';
import {
    assignRoleToUser,
    createUser,
    deleteUser,
    editUser,
    getAllRoles,
    getTenantContext,
    removeRoleFromUser,
    inviteUser,
    resetUserPass, makeUserSysAdmin, setUserNewPass, removeSysAdminRoleFromUser
} from '../../../../actions/boCoreActions';
import CrateUserModal from "./components/createUserModal/CreateUserModal";
import AgGridUtils from "../../../../AgGridUtils";
import AgGridHelpToolTip from "../../common/AgGridFilterHelpTooltip";
import './usersGrid.css'
import AccessControlModal, {Access, GridType} from "../../../common/AccessControlModal/AccessControlModal";
import InviteUserModal from "./components/inviteUserModal/InviteUserModal";
import {AxiosPromise} from "axios";
import SetUserPasswordModal from "./components/setPasswordModal/SetUserPasswordModal";
import {connect} from "react-redux";

const AgGridReact = require('ag-grid-react').AgGridReact;

interface State {
    columnDefs: any;
    rowData: any;
    gridApi: any;
    columnApi: any;
    loading: boolean;
    showModal: boolean;
    selectedUser: any;
    tenant: any;
    roles: any;
    modalBtnText: string;
    modalUserInfo: any;
    gridType: GridType;
    access: Access;
    showRoleInfoModal: boolean;
    showInviteUserModal: boolean;
    showSetPassModal: boolean;
}

interface Props {
    renderInModal?: boolean,
    funcId?: number,
    access?: Access,
    role?: string,
    user: any
}

class UsersGrid extends React.Component<Props, State> {
    historyFilter: boolean = false;

    constructor(props: Props) {
        super(props);
        this.state = {
            columnDefs: [],
            rowData: [],
            gridApi: null,
            columnApi: null,
            loading: false,
            tenant: null,
            showModal: false,
            selectedUser: null,
            roles: [],
            modalBtnText: 'Manage Users Access Control',
            modalUserInfo: null,
            gridType: null,
            access: null,
            showRoleInfoModal: false,
            showInviteUserModal: false,
            showSetPassModal: false,
        };
    }

    componentDidMount() {
        this.buildGrid();
        document.addEventListener('keydown', this.keydownHandler);
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.keydownHandler);
    }

    keydownHandler = (e) => {
        if (e.shiftKey && e.keyCode === 40) {
            e.preventDefault();
            Utils.$('.ag-floating-filter-input')[0].focus();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 78) {
            Utils.$('#new-user-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 69) {
            Utils.$('#edit-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 73) {
            Utils.$('#invite-user-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 83) {
            Utils.$('#set-pass-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 82) {
            Utils.$('#reset-pass-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 68) {
            Utils.$('#delete-btn').click();
        }
        if (e.keyCode === 9) {
            e.preventDefault();
            const element = document.activeElement;
            const id = element.id.split('-')[3];

            if (element.classList.contains("ag-floating-filter-input")) {
                if (Utils.$('.ag-floating-filter-input').length - 1 === Number.parseInt(id)) {
                    this.setGridFistCellOnFocus(e);
                } else {
                    const index = Number.parseInt(id) + 1;
                    Utils.$('.ag-floating-filter-input')[index].focus();
                }
            }
        }
    };

    buildGrid = () => {
        let columnDefs = [
            {
                id: "",
                headerName: "ID",
                field: "id",
                headerTooltip: "id",
                type: 'text',
                width: 120,
                suppressSizeToFit: true,
                checkboxSelection: true,
                headerComponent: AgSelectAllHeader,
                dataType: AttributeTypeEnum.INT,
            },
            {
                field: 'firstName',
                headerName: "First Name",
                tooltipField: 'firstName',
                headerTooltip: "firstName",
                type: 'text',
                cellRenderer: (params:any) =>{
                    const isAdmin = params.data?.systemAdministrator ? `<i class="fas fa-user-cog"></i>` : `<span><span>`
                    const adminIconContainer =  document.createElement('span')
                         adminIconContainer.innerHTML = `${isAdmin}<span style="margin-left:5px;">${params.value}</span> `
                        
                    return adminIconContainer
                }
            },
            {
                field: 'lastName',
                headerName: "Last Name",
                tooltipField: 'lastName',
                headerTooltip: "lastName",
                type: 'text',
                cellRenderer: (params) => {
                    return params.value;
                }
            },
            {
                field: 'email',
                headerName: "Email",
                tooltipField: 'email',
                headerTooltip: "email",
                type: 'text',
                cellRenderer: (params) => {
                    return params.value;
                }
            },
            {
                field: 'enabled',
                headerName: "Enabled",
                tooltipField: 'enabled',
                headerTooltip: "enabled",
                hide: true,
                lockVisible: true
            },
            {
                field: 'roles',
                headerName: "Roles",
                tooltipField: 'roles',
                headerTooltip: "roles",
                type: 'text',
                cellRenderer: (params) => {
                    return params.value.join(', ')
                }
            },
            {
                field: 'groups',
                headerName: "Groups",
                tooltipField: 'Groups',
                headerTooltip: "Groups",
                cellRenderer: (params) => {
                    const groupsNames = params.value.map(group => {
                        return group.groupName
                    })
                    return groupsNames.sort().join(', ')
                }
            },
            {
                field: 'userFunctionalities',
                headerName: "User Functionalities",
                tooltipField: 'User Functionalities',
                headerTooltip: "User Functionalities",
                sortable: false,
                filter: false,
                floatingFilter: false,
                width: 140,
                minWidth: 140,
                type: 'action',
                hide: this.props.renderInModal,
                lockVisible: this.props.renderInModal,
                cellRenderer: (params: any) => {
                    const eDiv = document.createElement('div');
                    eDiv.innerHTML = `<button title="User - Allowed Functionalities" id="show-allowed-funcs" class="show-allowed-btn">F</button>
                                       <button title="User - Denied Functionalities" id="show-denied-funcs" class="show-denied-btn" style="margin-left: 8px">F</button>`

                    const eButtonUsersAllowed = eDiv.querySelectorAll('#show-allowed-funcs')[0];
                    const eButtonUsersDenied = eDiv.querySelectorAll('#show-denied-funcs')[0];
                    eDiv.style.cssText = 'display: flex; white-space: initial; width: 100%; justify-content: center;  padding: 3px 0 3px 0';

                    eButtonUsersAllowed.addEventListener('click', (event) => {
                        event.stopImmediatePropagation();
                        Utils.blurTheActiveElements();
                        this.setAccessControlModalProps(GridType.FUNCTIONALITIES, Access.ALLOWED, {
                            id: params.data.id,
                            name: params.data.firstName + " " + params.data.lastName
                        });
                    });

                    eButtonUsersDenied.addEventListener('click', (event) => {
                        event.stopImmediatePropagation();
                        Utils.blurTheActiveElements();
                        this.setAccessControlModalProps(GridType.FUNCTIONALITIES, Access.DENIED, {
                            id: params.data.id,
                            name: params.data.firstName + " " + params.data.lastName
                        });
                    });

                    return eDiv;
                }
            },
        ];

        this.setState({
            columnDefs: columnDefs
        }, () => this.addFilterIndex())
    }

    addFilterIndex = () => {
        Utils.$(".ag-floating-filter-input").each(function (index) {
            Utils.$(this).attr('id', 'users-search-filter-' + index);
            Utils.$(this).attr('index', (index + 2));
        });
    };

    setAccessControlModalProps = (gridType: GridType, access: Access, user: any) => {
        this.setState({
            gridType,
            access,
            modalUserInfo: {
                ...this.state.modalUserInfo,
                id: user.id,
                name: user.name
            }
        }, () => this.showAccessControlModal())
    }

    onGridReady = (params) => {
        if (!this.state.gridApi && !this.state.columnApi) {
            this.setState({
                gridApi: params.api,
                columnApi: params.columnApi
            }, () => {
                params.api.sizeColumnsToFit();
                $("#hide-nav-btn").on("click", function () {
                    setTimeout(() => {
                        params.api.sizeColumnsToFit();
                    }, 500);
                });
            })
        }
        params.api.setServerSideDatasource(this.ServerSideDatasource());
    }

    onGridReadyFirstRender = (params) => {
        this.setState({
            gridApi: params.api,
            columnApi: params.columnApi
        }, () => {
            this.setFilterFromHistory();
            params.api.sizeColumnsToFit();
            $("#hide-nav-btn").on("click", function () {
                setTimeout(() => {
                    params.api.sizeColumnsToFit();
                }, 500);
            });
        })
    }

    setFilterFromHistory = () => {
        // @ts-ignore
        if (history.location.state && history.location.state.id) {
            this.historyFilter = true;
            this.state.gridApi.setFilterModel({
                id: {
                    filterType: "text",
                    type: "contains",
                    //@ts-ignore
                    filter: `=="${history.location.state.id}"`
                }
            })
            history.replace({
                ...history.location,
                state: undefined
            })
        }
    }

    setGridFistCellOnFocus = (event) => {
        if (event.keyCode === 9) {
            event.preventDefault();

            // scrolls to the first row
            this.state.gridApi.ensureIndexVisible(0);

            // scrolls to the current column
            let currentCol = this.state.columnApi.getAllDisplayedColumns()[0];
            this.state.gridApi.ensureColumnVisible(currentCol);

            // sets focus into the grid cell
            this.state.gridApi.setFocusedCell(0, currentCol);
        }
    };

    ServerSideDatasource() {
        return {
            getRows: (params: any) => {
                const limit = params.request.endRow - params.request.startRow;
                const page = (params.request.endRow / limit) - 1;
                const sortObj = AgGridUtils.generateSortData(params.request.sortModel);
                const sortKeys = Object.keys(sortObj);
                let sort = sortKeys.length > 0 ? `&sort=${sortKeys[0] + ';' + sortObj[sortKeys[0]]}` : '';
                const filter = AgGridUtils.generateFilterDataV2(params);
                let apiPath = `user/all?size=${limit}&page=${page}${sort}&${filter}`;

                if (this.props.renderInModal && this.props.access && this.props.funcId) {
                    apiPath = `user/func/${this.props.funcId}/all?allowed=${this.props.access === Access.ALLOWED}&size=${limit}&page=${page}${sort}&${filter}`
                } else if (this.props.renderInModal && this.props.role) {
                    apiPath = `user/role/all?role=${this.props.role}&size=${limit}&page=${page}${sort}&${filter}`
                }

                Axios.instanceV2.get(apiPath)
                    .then((response: any) => {
                        const gridData = response.data.data.map(item => {
                            return {
                                id: item.id,
                                firstName: item.mta ? 'MTA' : item.firstName,
                                lastName: item.mta ? 'MTA' : item.lastName,
                                userName: item.userName,
                                email: item.email,
                                enabled: item.enabled,
                                roles: item.roles,
                                groups: item.groups,
                                systemAdministrator: item.systemAdministrator
                            }
                        });

                        if (gridData.length === 0) {
                            this.state.gridApi.showNoRowsOverlay()
                        }
                        try {
                            const lastRow = gridData.length < limit ? params.request.startRow + gridData.length : -1;
                            params.successCallback(gridData, lastRow);
                            this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.update(response.data.totalElements,
                                (limit * (page + 1)) > response.data.totalElements ?
                                    response.data.totalElements : (limit * (page + 1)),
                                params.parentNode.gridApi.getSelectedRows().length);

                            if (this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.isSelected()) {
                                this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.selectAll();
                            }

                            this.state.gridApi.sizeColumnsToFit();
                            this.forceUpdate();
                        } catch (e) {
                            console.error(e);
                        }

                    })
                    .catch((e) => {
                        AgGridUtils.serverSideErrorHandler(e)
                        params.failCallback();
                    })
                    .finally(() => {
                        if (this.historyFilter) {
                            this.state.gridApi.forEachNode(node => node.rowIndex ? 0 : node.setSelected(true))
                            this.historyFilter = false;
                        }
                    })
            }
        }
    }

    onNewHandler = () => {
        this.getModalData()
            .then(response => {
                if (response) {
                    Utils.blurTheActiveElements()
                    this.setState({
                        showModal: response.showModal,
                        tenant: response.tenant,
                        roles: response.roles
                    })
                }
            })
        document.removeEventListener('keydown', this.keydownHandler);
    }

    getModalData = async () => {
        const [tenant, roles] = await Promise.all([
            getTenantContext(),
            getAllRoles()
        ]);

        if (tenant && tenant.data && roles && roles.data.data) {
            return {
                showModal: true,
                tenant: {
                    id: tenant.data.id,
                    name: tenant.data.name
                },
                roles: roles.data.data.map(role => {
                    return {
                        id: role.id,
                        value: role.id,
                        label: role.roleName,
                    }
                })
            }
        }
        return null;
    }

    hideModal = () => {
        this.setState({
            selectedUser: null,
            roles: [],
            showModal: false
        })
    }

    restoreEventListener = () => {
        document.addEventListener('keydown', this.keydownHandler);
    }

    onEditHandler = () => {
        const selected = this.state.gridApi.getSelectedRows();
        if (selected.length === 0) {
            toastr.warning("Please select one user");
            return;
        }
        this.getModalData()
            .then(response => {
                if (response) {
                    Utils.blurTheActiveElements();
                    this.setState({
                        showModal: response.showModal,
                        tenant: response.tenant,
                        roles: response.roles,
                        selectedUser: selected[0],
                    })
                }
            })
        document.removeEventListener('keydown', this.keydownHandler);
    }

    onDeleteHandler = () => {
        const selectedRows = this.state.gridApi.getSelectedRows()
        if (selectedRows.length === 1) {
            Utils.blurTheActiveElements();
            Utils.$.confirm({
                title: 'Confirm?',
                keyboardEnabled: true,
                escapeKey: 'cancel',
                backgroundDismiss: false,
                theme: 'dark',
                typeAnimated: false,
                content: `You are about to delete 1 user, this procedure is irreversible.`,
                type: 'red',
                buttons: {
                    ok: {
                        text: "Yes!",
                        btnClass: 'btn-danger',
                        keys: ['enter'],
                        action: () => {
                            deleteUser(selectedRows[0].id)
                                .then(() => {
                                    this.refreshGrid();
                                })
                        }
                    },
                    cancel: () => {
                    }
                }
            });
        } else if (selectedRows.length > 1) {
            //TODO bulk delete
        } else {
            toastr.warning("Please select one user");
        }
    }

    onRowSelected = (params) => {
        setTimeout(() => {
            this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.onRowSelected(params);
            this.forceUpdate();
            if (this.props.renderInModal) {
                this.setState({
                    modalBtnText: this.state.gridApi.getSelectedRows().length > 0 ? 'Edit User Access' : 'Manage Users Access Control'
                })
            }
        }, 0)
    }

    createUser = (user) => {
        const roles = user.addedRoles;
        delete user.addedRoles;
        createUser(user)
            .then((response) => {
                this.assignRoles(response.data.id, roles)
                this.refreshGrid();
            })
            .finally(() => {
                this.hideModal();
            })
    }

    editUser = async (user) => {
        const {selectedUser} = this.state;
        let hasChanges = false;
        const requests = [];

        if (user.addedRoles.length !== 0 || user.removedRoles.length !== 0) {
            hasChanges = true
            user.addedRoles?.forEach(role => {
                requests.push(assignRoleToUser(selectedUser.id, role))
            })
            user.removedRoles?.forEach(role => {
                requests.push(removeRoleFromUser(selectedUser.id, role))
            })
        }

        if (user.systemAdministrator !== selectedUser.systemAdministrator) {
            hasChanges = true;
            if (user.systemAdministrator) {
                requests.push(makeUserSysAdmin(selectedUser.id));
            } else {
                requests.push(removeSysAdminRoleFromUser(selectedUser.id));
            }
        }

        if (user.firstName !== selectedUser.firstName || user.lastName !== selectedUser.lastName || user.email !== selectedUser.email) {
            hasChanges = true;
            delete user.addedRoles;
            delete user.removedRoles;
            delete user.systemAdministrator;
            requests.push(editUser(selectedUser.id, user))
        }

        if (hasChanges) {
            try {
                const [response] = await Promise.all(requests);
                if (response) {
                    this.refreshGrid();
                    this.hideModal();
                    return response
                }
            } catch (e) {
                this.hideModal();
                return e;
            }
        } else {
            toastr.warning('There are no changes')
        }
    }

    assignRoles = async (userId: number, addedRoles: any) => {
        const requests = [];
        addedRoles?.forEach(role => {
            requests.push(assignRoleToUser(userId, role))
        })
        try {
            const [response] = await Promise.all(requests);
            if (response) {
                this.refreshGrid()
            }
        } catch (e) {
            this.hideModal();
        }
    }

    showUsersPage = () => {
        if (this.state.gridApi.getSelectedRows().length > 0) {
            history.push({
                pathname: `${process.env.ENV_PREFIX}/users`,
                state: {
                    id: this.state.gridApi.getSelectedRows()[0].id
                }
            });
        } else {
            history.push(`${process.env.ENV_PREFIX}/users`)
        }
    }

    setPassToUser = () => {
        const selectedRows = this.state.gridApi.getSelectedRows()
        if (selectedRows.length === 1) {
            document.removeEventListener('keydown', this.keydownHandler);
            Utils.blurTheActiveElements();
            this.setState({
                selectedUser: selectedRows[0],
                showSetPassModal: true
            })
        } else {
            toastr.warning("Please select one user")
        }
    }

    resetUserPass = () => {
        const selectedRows = this.state.gridApi.getSelectedRows()
        if (selectedRows.length === 1) {
            Utils.blurTheActiveElements();
            resetUserPass(selectedRows[0].id)
                .catch((err) => {
                    console.error(err);
                })
        } else {
            toastr.warning("Please select one user")
        }
    }

    showAccessControlModal = () => {
        this.setState({
            showRoleInfoModal: true
        })
    }

    hideAccessControlModal = () => {
        this.setState({
            showRoleInfoModal: false,
            access: null,
            gridType: null,
            modalUserInfo: null
        })
    }

    inviteUser = () => {
        document.removeEventListener('keydown', this.keydownHandler);
        Utils.blurTheActiveElements();
        this.setState({
            showInviteUserModal: true
        });
    }

    closeInviteUserModal = () => {
        this.setState({
            showInviteUserModal: false
        }, this.restoreEventListener)
    }

    inviteUserRequest = (dto: any): AxiosPromise => {
        return inviteUser(dto)
    }

    refreshGrid = () => {
        this.state.gridApi.onFilterChanged();
    }

    setUserNewPassword = (dto: any) => {
        return setUserNewPass(this.state.selectedUser.id, dto);
    }

    closeSetPassModal = () => {
        this.setState({
            showSetPassModal: false
        }, this.restoreEventListener)
    }

    render() {
        return (
            <div style={{height: 'calc(100% - 70px)'}} className={'access-control-grid'}>
                {this.props.renderInModal === true ? null :
                    <header style={{height: 50, display: "flex"}} className="bo-core-header top-header">
                        <div style={{
                            float: "left",
                            paddingLeft: 4,
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}>
                            <span id="usersSearchTitle" className="header-title">Users</span>
                            <div className="control-buttons">
                                <button onClick={this.onNewHandler} style={{marginRight: 2, height: 36}}
                                        className="btn btn-new-design"
                                        id={'new-user-btn'} title={'CTRL + ALT + N'}>
                                    <i className="fas fa-plus"/> <strong style={{fontSize: '13px'}}
                                                                         className={'shortcut-btn-letters'}>N</strong>ew
                                </button>
                                <button onClick={this.onEditHandler} style={{marginRight: 2, height: 36}}
                                        className="btn btn-new-design"
                                        id={'edit-btn'} title={'CTRL + ALT + E'}>
                                    <i className="fas fa-user-edit"/> <strong style={{fontSize: '13px'}}
                                                                         className={'shortcut-btn-letters'}>E</strong>dit
                                </button>
                                <button onClick={this.inviteUser} style={{marginRight: 2, height: 36}}
                                        className="btn btn-new-design"
                                        id={'invite-user-btn'} title={'CTRL + ALT + I'}>
                                    <i className="fas fa-user-plus"/> <strong style={{fontSize: '13px'}}
                                                                              className={'shortcut-btn-letters'}>I</strong>nvite
                                </button>
                                {this.props.user && (this.props.user.mta || this.props.user.systemAdministrator) ? <button onClick={this.setPassToUser} style={{marginRight: 2, height: 36}}
                                        className="btn btn-new-design"
                                        id={'set-pass-btn'} title={'CTRL + ALT + S'}>
                                    <i className="fas fa-key"/> <strong style={{fontSize: '13px'}}
                                                                         className={'shortcut-btn-letters'}>S</strong>et Password
                                </button> : null}
                                <button onClick={this.resetUserPass} style={{marginRight: 2, height: 36}}
                                        className="btn btn-new-design"
                                        id={'reset-pass-btn'} title={'CTRL + ALT + R'}>
                                    <i className="fas fa-edit"/> <strong style={{fontSize: '13px'}}
                                                                         className={'shortcut-btn-letters'}>R</strong>eset Password
                                </button>
                                <button onClick={this.onDeleteHandler} style={{height: 36}}
                                        id={'delete-btn'}
                                        title={'CTRL + ALT + D'}
                                        className="btn btn-danger">
                                    <i className="fas fa-trash-alt"/> <strong style={{fontSize: '13px'}}
                                                                              className={'shortcut-btn-letters'}>D</strong>elete
                                </button>
                            </div>
                        </div>
                    </header>}

                <div id={this.props.renderInModal === true ? 'modal-users-grid' : 'users-grid'}>
                    <div style={{height: '100%'}}>
                        {this.props.renderInModal === true ?
                            <header className={'instance-layout-grid-header'} style={{height: 40}}>
                                <h5>Users</h5>
                                <button onClick={this.showUsersPage}
                                        style={{height: 33, marginTop: 3, marginRight: 3}}
                                        className="btn new-style-btn">{this.state.modalBtnText}</button>
                            </header> : null}
                        <div style={{width: "100%", height: "99%"}} className={"ag-theme-balham-dark ag-grids"}>
                            <AgGridReact
                                onGridReady={this.onGridReady}
                                onFirstDataRendered={this.onGridReadyFirstRender}
                                columnDefs={this.state.columnDefs}
                                rowData={this.state.rowData}
                                onRowSelected={this.onRowSelected}
                                onFilterChanged={() => AgGridUtils.deselectAllRows(this.state.gridApi)}
                                defaultColDef={{
                                    minWidth: 150,
                                    flex: 1,
                                    filter: "agTextColumnFilter",
                                    floatingFilter: true,
                                    sortable: true,
                                    autoHeight: true,
                                    resizable: true,
                                    tooltipComponent: AgGridHelpToolTip,
                                    headerComponentParams: {
                                        template: helpHeaderTemplate
                                    },
                                    filterParams: {
                                        filterOptions: ['contains'],
                                        applyButton: true,
                                        clearButton: true,
                                        suppressAndOrCondition: true
                                    },
                                    floatingFilterComponentParams: {suppressFilterButton: true},
                                }}
                                gridOptions={{
                                    suppressDragLeaveHidesColumns: true,
                                    floatingFilter: true,
                                    rowSelection: "single",
                                    rowModelType: 'serverSide',
                                    suppressCellSelection: true,
                                    blockLoadDebounceMillis: 300,
                                    enableCellTextSelection: true
                                }}
                            >
                            </AgGridReact>
                            <AgGridFooter
                                totalCount={this.state.gridApi ? this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.getState().totalItemsCount : 0}
                                loadedCount={this.state.gridApi ? this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.getState().loadedItemsCount : 0}
                                selectedCount={this.state.gridApi ? this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.getState().selectedItemsCount : 0}
                            />
                        </div>
                    </div>
                    <AccessControlModal
                        modalTitle={`${this.state.modalUserInfo?.name} - ${this.state.access} ${this.state.gridType}`}
                        showModal={this.state.showRoleInfoModal}
                        gridType={this.state.gridType}
                        access={this.state.access}
                        modalUserInfo={this.state.modalUserInfo}
                        closeModal={this.hideAccessControlModal}
                    />
                    <CrateUserModal
                        showModal={this.state.showModal}
                        hideModal={this.hideModal}
                        createUser={this.createUser}
                        editUser={this.editUser}
                        restoreEventListener={this.restoreEventListener}
                        tenant={this.state.tenant}
                        roles={this.state.roles}
                        selectedUser={this.state.selectedUser}
                    />
                    <InviteUserModal showInviteUserModal={this.state.showInviteUserModal}
                                     closeInviteUserModal={this.closeInviteUserModal}
                                     inviteUserRequest={this.inviteUserRequest}
                                     refreshGrid={this.refreshGrid}
                    />
                    <SetUserPasswordModal showSetPassModal={this.state.showSetPassModal}
                                          closeSetPassModal={this.closeSetPassModal}
                                          refreshGrid={this.refreshGrid}
                                          setNewPassRequest={this.setUserNewPassword}
                                          selectedUser={this.state.selectedUser}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {user: state.auth.user}
}

export default connect(mapStateToProps)(UsersGrid)



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/UsersGrid/UsersGrid.tsx